export default __webpack_public_path__ + "static/media/not_null.363ba60c.svg";